import { defineCopy } from "@tami/core/intl";

import { DASHBOARD_COLLAB_SCRIPT_COPY_EN_US } from "./en-us/dashboard-collab-script.copy";
import { DASHBOARD_COLLAB_SCRIPT_COPY_ES_ES } from "./es-es/dashboard-collab-script.copy";

export const DASHBOARD_COLLAB_SCRIPT_COPY_PT_BR = {
  dashCollabIntro: {
    narrative:
      "O mesmo painel, do lado de quem gerencia: o quadro inteiro de creators numa tela só.",
  },
  dashCollabScope: {
    narrative:
      "Escolha de quem você quer falar. Um creator, alguns, ou o quadro inteiro — a tela toda acompanha.",
    callout:
      "Filtre por creator num clique — inclusive pela sua própria Collab.",
  },
  dashCollabGreeting: {
    narrative:
      "Comece o dia sabendo o que cada creator precisa postar, entregar e resolver.",
    callout:
      "Bom dia, Ana! O resumo do quadro num relance.",
  },
  dashCollabOverview1: {
    narrative:
      "Menos planilha por creator — um lugar só para o quadro inteiro.",
  },
  dashCollabCards: {
    narrative:
      "Cada creator com seguidores e engajamento consolidados. Clique num card e desça até as redes dele.",
    callout:
      "Um card por creator — e a sua Collab também tem o dela.",
  },
  dashCollabOverview2: {
    narrative:
      "Comparação lado a lado, sem abrir uma aba por creator.",
  },
  dashCollabKpis: {
    narrative:
      "Receita, campanhas ativas, entregas pendentes e engajamento — somados do quadro inteiro.",
    callout:
      "KPIs consolidados: o que a Collab tem em campo agora.",
  },
  dashCollabOverview3: {
    narrative:
      "Sem achismo sobre quem está entregando e quem está parado.",
  },
  dashCollabPosts: {
    narrative:
      "A fila do dia com o dono de cada item — dá para varrer a coluna e saber de quem é o quê.",
    callout:
      "Toda postagem carrega o creator dono, inclusive o conteúdo da Collab.",
  },
  dashCollabAgenda: {
    narrative:
      "Gravações, calls e reuniões do quadro, com o creator de cada compromisso.",
    callout:
      "Agenda do quadro: quem grava, quem reúne, a que horas.",
  },
} as const;

export const DASHBOARD_COLLAB_SCRIPT_COPY = defineCopy(DASHBOARD_COLLAB_SCRIPT_COPY_PT_BR, {
  "en-US": DASHBOARD_COLLAB_SCRIPT_COPY_EN_US,
  "es-ES": DASHBOARD_COLLAB_SCRIPT_COPY_ES_ES,
});
